module.exports = __webpack_public_path__ + "img/stars-sky-img-png.48378c78.png";